import { communicationStore } from '@yoop/whitelabel-manager-store';
import { apiClientStore } from '@yoop/whitelabel-api-client';
import { CommsMessageActions } from '@yoop/whitelabel-data';

export const onRevokeToken = async (tokenId: string, requestKey: string) => {
  const { sendDataMessage } = communicationStore.getState();
  sendDataMessage({
    action: CommsMessageActions.ResaleEventsList,
    key: requestKey,
    getData: async () => {
      const { apiClient } = apiClientStore.getState();
      await apiClient.tokenController.revokeToken(tokenId);
    },
  });
};

export const onResendTokenInvite = async (assignmentId: string, requestKey: string) => {
  const { sendDataMessage } = communicationStore.getState();
  sendDataMessage({
    action: CommsMessageActions.ResaleEventsList,
    key: requestKey,
    getData: async () => {
      const { apiClient } = apiClientStore.getState();
      await apiClient.tokenController.resendInvite(assignmentId);
    },
  });
};

export const onReturnToken = async (tokenId: string, requestKey: string) => {
  const { sendDataMessage } = communicationStore.getState();
  sendDataMessage({
    action: CommsMessageActions.ResaleEventsList,
    key: requestKey,
    getData: async () => {
      const { apiClient } = apiClientStore.getState();
      await apiClient.tokenController.returnToken(tokenId);
    },
  });
};

export const onAssignTokenToCurrentUser = async (
  eventId: string,
  tokenId: string,
  requestKey: string,
) => {
  const { sendDataMessage } = communicationStore.getState();
  sendDataMessage({
    action: CommsMessageActions.ResaleEventsList,
    key: requestKey,
    getData: async () => {
      const { apiClient } = apiClientStore.getState();
      await apiClient.tokenController.selfAssignToken(eventId, tokenId);
    },
  });
};
